<div
  class="alert"
  [class.alert-small]="smallAlert"
  [ngClass]="type"
>
  <span
    [attr.aria-live]="suppressAnnouncement ? 'off' : 'assertive'"
    [attr.role]="suppressAnnouncement ? null : 'alert'"
  >
    <span class="sr-only">{{ getAlertType(type) | async }}</span>
    <ng-content></ng-content>
  </span>

  <button
    *ngIf="getIsClosable()"
    (click)="alertClose()"
    (focus)="onFocus()"
    (blur)="onBlur()"
    id="alert-close-button"
    class="close"
    title="{{ 'ngx-shared-close-this-alert' | translate | async }}"
    type="button"
  >
    <span aria-hidden="true"><i class="dpg-icon dpg-icon-system-close"></i></span>
  </button>
</div>
